module.exports = __webpack_public_path__ + "static/img/lbbg4.ef015c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg4.png
// module id = AmIo
// module chunks = 0